import AddIcon from "../../../assets/icons/addIcon.svg";
import AddIconLight from "../../../assets/lightIcons/create_new_light.svg";
import EditIcon from "../../../assets/icons/Edit.svg";
import EditIconLight from "../../../assets/lightIcons/edit_light.svg";
import { setModalModal } from "../../../redux/slices/modalSlice.js";

import {
  clearCreateTopic,
  setCreateTopicField,
  setCreateTopicItems,
} from "../../../redux/slices/createTopicSlice";
import ArrowForward from "../../../assets/icons/arrow_forward.svg";
import { FiChevronRight } from "react-icons/fi";
import Dots from "../../../assets/icons/three_dots.svg";
import DotsLight from "../../../assets/lightIcons/faqs_dots_light.svg";
import Edit from "../../../assets/icons/Edit.svg";
import EditLight from "../../../assets/lightIcons/edit_light.svg";
import Delete from "../../../assets/icons/Delete.svg";
import DeleteLight from "../../../assets/lightIcons/delete_light.svg";

import {
  React,
  useState,
  useRef,
  useDispatch,
  useEffect,
  useSelector,
  useModal,
  useNavigate,
} from "../../../globals/imports";
import {
  setTopicIdToDelete,
  setTopicNameToDelete,
  setTopicChannelToDelete,
} from "../../../redux/slices/deleteTopicSlice.js";
import { fetchTopics } from "../../../redux/slices/reorderTopicSlice.js";

const TopicsTab = ({ channelId, isOwner }) => {
  const { handleOpenModal } = useModal();
  const [isEditDropdownOpen, setIsEditDropdownOpen] = useState(null);
  const dropdownEditRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const reorderTopics = useSelector((state) => state.reorderTopic.topics);
  const status = useSelector((state) => state.reorderTopic.status);

  // Fetch this channel's topics when the tab mounts / the channel changes.
  // Required in the admin panel (which renders TopicsTab directly on expand);
  // the embed's ChannelPage already fetches, so this is just an idempotent
  // refetch there.
  useEffect(() => {
    if (channelId) dispatch(fetchTopics(channelId));
  }, [channelId, dispatch]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownEditRef.current &&
        !dropdownEditRef.current.contains(event.target)
      ) {
        setIsEditDropdownOpen(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleEditDropdown = (id) => {
    setIsEditDropdownOpen(id);
  };

  const handleTopicModal = (channelId) => {
    dispatch(clearCreateTopic());
    dispatch(setCreateTopicField({ field: "channel", value: channelId }));
    handleOpenModal("modalTopicOpen");
  };
  const handleReorderTopicModal = (channelId) => {
    handleOpenModal("modalTopicReorderOpen", channelId);
  };
  const handleTopic = (topicId) => {
    // The admin manages topics in place; there's no relative chat route to open
    // from /admin (it would land on a dead page). The dots menu handles edit/
    // delete. In the embed/app, the relative navigate opens the topic chat.
    if (window.location.pathname.startsWith("/admin")) return;
    navigate(`c-id/topic/${topicId}`);
  };

  if (status === "loading") {
    return (
      <div className="text-theme-secondaryText text-center mt-12 justify-center items-center">
        Loading...
      </div>
    );
  }

  const handleEditModal = (topic) => {
    const transformedData = {
      ...topic,
    };
    dispatch(setCreateTopicItems(transformedData));
    dispatch(setCreateTopicField({ field: "isEdit", value: true }));
    setTimeout(() => {
      handleOpenModal("modalTopicOpen");
    }, 500);
  };

  return (
    <div className="flex flex-col">
      {isOwner && (
        <div className="flex flex-row items-center justify-between">
          <div
            className="flex items-center cursor-pointer"
            onClick={() => handleTopicModal(channelId)}
          >
            <div className="rounded-lg mr-2 flex bg-theme-tertiaryBackground p-0.5  justify-center items-center">
              <img
                src={AddIcon}
                alt="Add"
                className="dark:block hidden w-5 h-5 text-theme-secondaryText"
              />
              <img
                src={AddIconLight}
                alt="Add"
                className="dark:hidden w-5 h-5 text-theme-secondaryText"
              />
            </div>
            <p className="text-theme-emptyEvent font-normal text-sm -ml-1">
              Create new
            </p>
          </div>
          <div className="relative flex pr-2">
            <div
              className="flex flex-col space-y-1 cursor-pointer text-sm font-light text-theme-emptyEvent"
              onClick={() => handleReorderTopicModal(channelId)}
            >
              Reorder
            </div>
          </div>
        </div>
      )}
      <div className="mx-1">
        {reorderTopics.length === 0 ? (
          <div className="text-theme-emptyEvent text-center mt-12 justify-center items-center">
            No topics found.
          </div>
        ) : (
          reorderTopics.map((topic, index) => (
            <div
              key={topic._id}
              className="bg-theme-tertiaryBackground rounded-lg px-4 py-4 flex cursor-pointer flex-row justify-between items-center my-3 "
              onClick={() => handleTopic(topic._id)}
            >
              <p className="text-theme-primaryText text-sm font-normal">
                #{topic.name}
              </p>
              <div className="flex flex-row items-center gap-4">
              {isOwner && (
                <div className="flex flex-row items-center space-x-4">
                  <img
                    src={Edit}
                    alt="edit"
                    title="Edit topic"
                    className="dark:block hidden w-4 h-4 cursor-pointer opacity-60 hover:opacity-100"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEditModal(topic);
                    }}
                  />
                  <img
                    src={EditLight}
                    alt="edit"
                    title="Edit topic"
                    className="dark:hidden w-4 h-4 cursor-pointer opacity-60 hover:opacity-100"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEditModal(topic);
                    }}
                  />
                  <img
                    src={Delete}
                    alt="delete"
                    title="Delete topic"
                    className="dark:block hidden w-4 h-4 cursor-pointer opacity-60 hover:opacity-100"
                    onClick={(e) => {
                      e.stopPropagation();
                      dispatch(setTopicIdToDelete(topic._id));
                      dispatch(setTopicNameToDelete(topic.name));
                      dispatch(setTopicChannelToDelete(topic.channel));
                      handleOpenModal("modalDeleteTopicOpen");
                    }}
                  />
                  <img
                    src={DeleteLight}
                    alt="delete"
                    title="Delete topic"
                    className="dark:hidden w-4 h-4 cursor-pointer opacity-60 hover:opacity-100"
                    onClick={(e) => {
                      e.stopPropagation();
                      dispatch(setTopicIdToDelete(topic._id));
                      dispatch(setTopicNameToDelete(topic.name));
                      dispatch(setTopicChannelToDelete(topic.channel));
                      handleOpenModal("modalDeleteTopicOpen");
                    }}
                  />
                </div>
              )}
                <FiChevronRight
                  size={18}
                  className="flex-shrink-0 text-theme-emptyEvent"
                />
              </div>
            </div>
          ))
        )}
      </div>
      <div className="h-4"></div>
    </div>
  );
};

export default TopicsTab;
